import { render, staticRenderFns } from "./ProjetosParaExcluirSistema.vue?vue&type=template&id=e2a2e46a"
import script from "./ProjetosParaExcluirSistema.vue?vue&type=script&lang=ts"
export * from "./ProjetosParaExcluirSistema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports